/**
 * AppOverlaySpinner Component
 *
 * Full-screen overlay spinner with smooth circular animation.
 * Drop-in replacement for OverlaySpinner with consistent styling.
 *
 * Usage:
 *   import AppOverlaySpinner from '../shared/AppOverlaySpinner';
 *
 *   if (loading) return <AppOverlaySpinner />;
 *
 *   // With custom tip
 *   <AppOverlaySpinner tip="Loading data..." />
 */

import React from 'react';
import PropTypes from 'prop-types';
import AppSpinner from './AppSpinner';
import { space, overlay } from '../../configs/designTokens';

const styles = {
  root: {
    alignItems: 'center',
    backgroundColor: overlay.white,
    display: 'flex',
    flexDirection: 'column',
    gap: space[3],
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1030,
  },
};

/**
 * AppOverlaySpinner - Full-screen loading overlay
 * @param {Object} props - Component props
 */
const AppOverlaySpinner = ({ tip }) => {
  return (
    <div style={styles.root}>
      <AppSpinner size="large" tip={tip} />
    </div>
  );
};

AppOverlaySpinner.propTypes = {
  /** Loading text shown below spinner */
  tip: PropTypes.string,
};

AppOverlaySpinner.defaultProps = {
  tip: undefined,
};

export default AppOverlaySpinner;
